module.exports = __webpack_public_path__ + "img/clienti.9c5281c9.png";